import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse, CollapseType, IconSize, LabelGutter } from '@as/cotopaxi';
import { BUCKET_FILTER, LINK_FILTER, MULTISELECT_FILTER, RANGE_FILTER, } from '@as-react/common-types';
import { Box } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { makeGetActiveFiltersState } from '../../../redux/lister/selectors/ListerSelector';
import { getSelectedFilterAmount } from '../../../util/FilterUtil';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { FilterItemContentBucketFilter } from './FilterItemContentBucketFilter';
import { FilterItemContentColorFilter } from './FilterItemContentColorFilter';
import { FilterItemContentLinkFilter } from './FilterItemContentLinkFilter';
import { FilterItemContentMultiSelect } from './FilterItemContentMultiSelect';
import { FilterItemContentRangeFilter } from './FilterItemContentRangeFilter';
import { FilterItemTitle } from './FilterItemTitle';
var TestMatchOptions;
(function (TestMatchOptions) {
    TestMatchOptions["EXACT"] = "exact";
    TestMatchOptions["REGEX"] = "regex";
})(TestMatchOptions || (TestMatchOptions = {}));
const dynamicFilterSelectors = [
    {
        test: [
            {
                key: 'type',
                value: MULTISELECT_FILTER,
                matching: TestMatchOptions.EXACT,
            },
            {
                key: 'filterOn',
                value: '^(?!.*colour).*$',
                matching: TestMatchOptions.REGEX,
            },
        ],
        component: FilterItemContentMultiSelect,
    },
    {
        test: [
            {
                key: 'type',
                value: MULTISELECT_FILTER,
                matching: TestMatchOptions.EXACT,
            },
            {
                key: 'filterOn',
                value: /^(.*colour).*$/g,
                matching: TestMatchOptions.REGEX,
            },
        ],
        component: FilterItemContentColorFilter,
    },
    {
        test: [
            {
                key: 'type',
                value: RANGE_FILTER,
                matching: TestMatchOptions.EXACT,
            },
        ],
        component: FilterItemContentRangeFilter,
    },
    {
        test: [
            {
                key: 'type',
                value: BUCKET_FILTER,
                matching: TestMatchOptions.EXACT,
            },
        ],
        component: FilterItemContentBucketFilter,
    },
    {
        test: [
            {
                key: 'type',
                value: LINK_FILTER,
                matching: TestMatchOptions.EXACT,
            },
        ],
        component: FilterItemContentLinkFilter,
    },
];
const dynamicFilterTesterFunction = (dynamicComponentTester, filterObj) => {
    switch (dynamicComponentTester.matching) {
        case TestMatchOptions.REGEX:
            return new RegExp(dynamicComponentTester.value).exec(String(filterObj[dynamicComponentTester.key])) !== null;
        case TestMatchOptions.EXACT:
            return filterObj[dynamicComponentTester.key] === dynamicComponentTester.value;
        default:
            return false;
    }
};
const dynamicFilterFunction = (dynamicComponentChecker, filterObj) => dynamicComponentChecker.test.every(tester => dynamicFilterTesterFunction(tester, filterObj));
export const FilterItem = ({ desktop, filter, onFilterItemChange, isCollapsedByDefault, filterWizardConfig, tooltip, totalItemsCount, urlFilters, }) => {
    var _a;
    const activeFilters = useSelector(makeGetActiveFiltersState());
    const DynamicFilter = dynamicFilterSelectors.find(dynamicFilterSelector => dynamicFilterFunction(dynamicFilterSelector, filter));
    if (DynamicFilter) {
        const DynamicComponent = DynamicFilter.component;
        const showFilterWizard = !!urlFilters && ((_a = filterWizardConfig === null || filterWizardConfig === void 0 ? void 0 : filterWizardConfig.filters) === null || _a === void 0 ? void 0 : _a.includes(filter.filterOn)) && filter.type !== RANGE_FILTER;
        return desktop ? (_jsx(Collapse, { id: `filter-item-collapse-${filter.name.replace(/ /g, '_').toLowerCase()}`, dataQA: filter.name.replace(/ /g, '_').toLowerCase(), open: !isCollapsedByDefault, iconSize: IconSize.MEDIUM, labelGutterVertical: LabelGutter.SMALL, type: CollapseType.FILTER_ITEM, title: _jsx(FilterItemTitle, { tooltip: !!tooltip && !showFilterWizard && _jsx(HtmlInclude, { htmlFragment: tooltip }), badge: getSelectedFilterAmount(filter, activeFilters), title: filter.name, showFilterWizard: showFilterWizard, filter: filter, filterWizardConfig: filterWizardConfig, updateFilters: onFilterItemChange, urlFilters: urlFilters, initialItemsCount: totalItemsCount }), children: _jsx(Box, { paddingBlockEnd: "2", children: _jsx(DynamicComponent, { toggleFilterOptions: filter.toggleFilterOptions, desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, isCollapsedByDefault: Boolean(isCollapsedByDefault) }) }) })) : (_jsx(DynamicComponent, { toggleFilterOptions: false, desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, isCollapsedByDefault: Boolean(isCollapsedByDefault) }));
    }
    return null;
};
